import { useEffect, useState } from "react";
import { timeAgo } from "@/lib/timeAgo";

// Live-updating relative time. Ticks every second so it keeps evolving.
export function TimeAgo({ ts, className }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!ts) return;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [ts]);
  return (
    <span className={className} title={ts ? new Date(ts).toLocaleString("fr-FR") : ""} data-testid="time-ago">
      {timeAgo(ts)}
    </span>
  );
}
